export const ASSET_A: string = '0x0101010101010101010101010101010101010101010101010101010101010101';
export const ASSET_B: string = '0x0202020202020202020202020202020202020202020202020202020202020202';
